(function(){
"use strict";
function init(){
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.classList.contains('reduced');
var hasGsap = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
if(reduced || !hasGsap) document.documentElement.classList.add('reduced');
if(hasGsap && !reduced) gsap.registerPlugin(ScrollTrigger);
var CUR = (window.ALUM && window.ALUM.currency) || 'AUD';
var moneyFmt = new Intl.NumberFormat('en-AU',{style:'currency',currency:CUR});
var money = function(cents){ return moneyFmt.format(cents/100)+' '+CUR; };
var $ = function(s,c){ return (c||document).querySelector(s); };
var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

/* ---------- CURSOR ---------- */
/* header offsets: hero fills the remaining viewport exactly */
var mainEl=document.querySelector('main');
function setHdr(){
  if(mainEl)document.documentElement.style.setProperty('--hdr',mainEl.offsetTop+'px');
  var nv=$('#nav');
  if(nv)document.documentElement.style.setProperty('--navh',nv.offsetHeight+'px');
}
setHdr();
addEventListener('resize',setHdr);
addEventListener('load',setHdr);

var cursor=$('#cursor'),dot=$('#cursorDot'),cLabel=$('#cursorLabel');
var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
if(fine && cursor){
  var cx=innerWidth/2,cy=innerHeight/2,tx=cx,ty=cy;
  document.addEventListener('mousemove',function(e){tx=e.clientX;ty=e.clientY;
    dot.style.transform='translate('+(tx-4.5)+'px,'+(ty-4.5)+'px)';});
  (function loop(){cx+=(tx-cx)*.16;cy+=(ty-cy)*.16;
    cursor.style.transform='translate('+(cx-17)+'px,'+(cy-17)+'px)';requestAnimationFrame(loop);})();
  document.addEventListener('mouseover',function(e){
    var t=e.target.closest('[data-cursor]');
    if(t){cursor.classList.add('is-active');dot.classList.add('is-active');cLabel.textContent=t.getAttribute('data-cursor-label')||'';}
    else{cursor.classList.remove('is-active');dot.classList.remove('is-active');}
  });
  document.addEventListener('mousedown',function(){cursor.classList.add('is-blue')});
  document.addEventListener('mouseup',function(){cursor.classList.remove('is-blue')});
}else if(cursor){cursor.style.display='none';dot.style.display='none';}

/* ---------- HERO INTRO (fail-safe: default state is visible; GSAP animates FROM hidden) ---------- */
function heroIn(){
  var spans=$$('.hero-title span');
  if(!(hasGsap && !reduced) || !spans.length) return;
  gsap.from(spans,{yPercent:112,duration:1.1,stagger:.07,ease:'power4.out',overwrite:'auto',clearProps:'transform'});
  if($('#heroSub'))gsap.from('#heroSub',{opacity:0,y:14,duration:.8,delay:.5,ease:'power3.out',overwrite:'auto',clearProps:'all'});
  if($('#heroCue'))gsap.from('#heroCue',{opacity:0,y:14,duration:.8,delay:.65,ease:'power3.out',overwrite:'auto',clearProps:'all'});
}
heroIn();

/* ---------- NAV + PROGRESS ---------- */
var nav=$('#nav'),lastY=0,pbar=$('#progressBar');
addEventListener('scroll',function(){
  var y=scrollY;
  if(nav){nav.classList.toggle('is-solid',y>40);
    nav.classList.toggle('is-hidden',y>lastY&&y>320&&!document.body.classList.contains('locked'));}
  lastY=y;
  if(pbar){var d=document.documentElement;
    pbar.style.transform='scaleX('+(y/(d.scrollHeight-innerHeight)||0)+')';}
},{passive:true});

/* ---------- ASSEMBLY ---------- */
function initAssembly(){
var stage=$('#asStage');
if(!stage||stage.dataset.asInit)return;
stage.dataset.asInit='1';
if(stage){
  var stepEl=$('#asStep'),stepCount=$('#asStepCount'),asBar=$('#asBar');
  var lottieBox=$('#lottieBox');
  if(lottieBox && window.lottie){
    var anim=window.lottie.loadAnimation({container:lottieBox,renderer:'svg',
      loop:false,autoplay:false,path:lottieBox.getAttribute('data-lottie')});
    var lotStep=function(p){
      asBar.style.transform='scaleX('+p+')';
      stepEl.textContent=p<.02?'Scroll to begin':'Assembly — '+Math.round(p*100)+'%';
      stepCount.textContent=Math.round(p*100)+' %';
      var tf=anim.totalFrames||0;
      if(tf>0)anim.goToAndStop(Math.min(tf-1,p*tf),true);
    };
    if(hasGsap && !reduced){
      ScrollTrigger.create({trigger:'#asStage',start:'top top',end:'+=2400',
        scrub:.55,pin:true,anticipatePin:1,invalidateOnRefresh:true,onUpdate:function(self){lotStep(self.progress)}});
    }else{
      anim.loop=true;anim.autoplay=true;
      anim.addEventListener('DOMLoaded',function(){anim.play()});
      lotStep(1);
    }
  }else{
  var STEPS=["01 / Seat the panels","02 / Drop the brace","03 / Thread the bolts","04 / Place the top"];
  var setStep=function(p){
    asBar.style.transform='scaleX('+p+')';
    var i=p<.28?0:p<.55?1:p<.8?2:3;
    stepEl.textContent=p<.02?"Scroll to begin":(p>.97?"Assembled — 4 min, one allen key":STEPS[i]);
    stepCount.textContent=(p<.02?"00":"0"+(i+1))+" / 04";
  };
  if(hasGsap && !reduced){
    gsap.set('#pTop',{y:-170});
    gsap.set('#pLeft',{x:-160,rotation:-8,transformOrigin:'50% 50%'});
    gsap.set('#pRight',{x:160,rotation:8,transformOrigin:'50% 50%'});
    gsap.set('#pBrace',{y:150});
    gsap.set('#bolt1',{x:-70,y:80,rotation:120,transformOrigin:'50% 50%'});
    gsap.set('#bolt2',{x:70,y:90,rotation:-120,transformOrigin:'50% 50%'});
    gsap.set('#bolt3',{x:-95,y:40,rotation:90,transformOrigin:'50% 50%'});
    gsap.set('#bolt4',{x:95,y:50,rotation:-90,transformOrigin:'50% 50%'});
    var tl=gsap.timeline({scrollTrigger:{trigger:'#asStage',start:'top top',end:'+=2400',
      scrub:.55,pin:true,anticipatePin:1,invalidateOnRefresh:true,onUpdate:function(self){setStep(self.progress)}}});
    tl.to(['#pLeft','#pRight'],{x:0,rotation:0,duration:.9,ease:'power2.inOut'})
      .to('#ann1',{opacity:1,duration:.2},'-=.2')
      .to('#pBrace',{y:0,duration:.7,ease:'power2.inOut'})
      .to('#ann2',{opacity:1,duration:.2},'-=.15')
      .to(['#bolt1','#bolt2','#bolt3','#bolt4'],{x:0,y:0,rotation:0,duration:.8,stagger:.12,ease:'back.out(1.4)'})
      .to('#ann3',{opacity:1,duration:.2},'-=.2')
      .to('#pTop',{y:0,duration:.8,ease:'power3.inOut'})
      .to(['#dimW','#dimH'],{opacity:1,duration:.3})
      .to('#asStamp',{scale:1,duration:.4,ease:'back.out(2)'});
  }else{
    setStep(1);
    if($('#asStamp'))$('#asStamp').style.transform='rotate(-6deg) scale(1)';
    ['ann1','ann2','ann3','dimW','dimH'].forEach(function(id){var el=$('#'+id);if(el)el.style.opacity=1});
  }
  }
}
}
initAssembly();

/* recalc pin positions once media has loaded (fixes overlay on scroll-up) */
if(hasGsap && !reduced){
  window.addEventListener('load',function(){ScrollTrigger.refresh()});
  var pending=$$('img').filter(function(im){return !im.complete});
  var left=pending.length;
  pending.forEach(function(im){im.addEventListener('load',function(){if(--left<=0)ScrollTrigger.refresh()},{once:true});
    im.addEventListener('error',function(){if(--left<=0)ScrollTrigger.refresh()},{once:true});});
}

/* ---------- REVEALS + COUNTERS (scoped, re-runnable) ---------- */
function initReveals(scope){
  if(!(hasGsap && !reduced))return;
  $$('[data-reveal]',scope).forEach(function(el){
    if(el.dataset.revInit)return;el.dataset.revInit='1';
    gsap.from(el,{opacity:0,y:26,duration:.9,ease:'power3.out',
      scrollTrigger:{trigger:el,start:'top 88%'}});
  });
}
function initCounters(scope){
  var els=$$('[data-count]',scope);
  if(hasGsap && !reduced){
    els.forEach(function(el){
      if(el.dataset.cntInit)return;el.dataset.cntInit='1';
      var end=parseFloat(el.getAttribute('data-count'))||0;
      gsap.fromTo(el,{innerText:0},{innerText:end,duration:1.4,ease:'power2.out',snap:{innerText:1},
        scrollTrigger:{trigger:el,start:'top 90%'},
        onUpdate:function(){el.textContent=Math.round(gsap.getProperty(el,'innerText'))}});
    });
  }else{
    els.forEach(function(el){el.textContent=el.getAttribute('data-count')});
  }
}
initReveals(document);initCounters(document);

/* ---------- MARQUEE + ANNOUNCEMENT (measure & clone for seamless loop) ---------- */
function setupMarquee(track){
  if(!track || track.dataset.mqInit) return;
  track.dataset.mqInit = '1';
  var set = document.createElement('span');
  set.className = 'mq-set';
  set.innerHTML = track.innerHTML;
  track.innerHTML = '';
  track.appendChild(set);
  var spd = parseFloat(getComputedStyle(track).getPropertyValue('--mq')) || 24;
  function build(){
    $$('.mq-set', track).forEach(function(el, i){ if(i > 0) el.remove(); });
    var cont = (track.parentElement && track.parentElement.offsetWidth) || innerWidth;
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    var unit = set.offsetWidth + gap;
    if(unit < 10) return; /* fonts not laid out yet — the load handler re-runs us */
    var copies = Math.ceil((cont + unit) / unit) + 1;
    for(var i = 1; i < copies; i++) track.appendChild(set.cloneNode(true));
    track.style.setProperty('--shift', unit + 'px');
    /* keep perceived speed consistent regardless of text length:
       the speed setting ≈ seconds per ~1200px of travel */
    track.style.animationDuration = Math.max(5, spd * unit / 1200) + 's';
  }
  build();
  addEventListener('load', build);
  var rT = null;
  addEventListener('resize', function(){ clearTimeout(rT); rT = setTimeout(build, 200); });
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(build);
}
setupMarquee($('#marqueeTrack'));
setupMarquee($('#announceTrack'));
var clockEl=$('#melbTime');
if(clockEl){
  var tick=function(){try{
    clockEl.textContent='MEL '+new Intl.DateTimeFormat('en-AU',{hour:'2-digit',minute:'2-digit',hour12:false,timeZone:'Australia/Melbourne'}).format(new Date());
  }catch(e){}};
  tick();setInterval(tick,30000);
}

/* ---------- ACCORDIONS ---------- */
document.addEventListener('click',function(e){
  var h=e.target.closest('[data-acc]');if(!h)return;
  var item=h.parentElement,body=item.querySelector('.acc-body'),open=item.classList.contains('is-open');
  var acc=item.parentElement;
  $$('.acc-item',acc).forEach(function(i){i.classList.remove('is-open');i.querySelector('.acc-body').style.maxHeight=null});
  if(!open){item.classList.add('is-open');body.style.maxHeight=body.scrollHeight+'px';}
});

/* ---------- TOAST ---------- */
var toastEl=$('#toast'),toastT=null;
function toast(msg){if(!toastEl)return;toastEl.textContent=msg;toastEl.classList.add('is-on');
  clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove('is-on')},2400);}

/* ---------- CART (Shopify AJAX) ---------- */
var drawer=$('#cartDrawer');
function badge(n){var b=$('#cartBadge');if(b){b.textContent=n;
  b.classList.add('pop');setTimeout(function(){b.classList.remove('pop')},350);}
  var c=$('#cartCount');if(c)c.textContent=n;
  $$('[data-cart-count]').forEach(function(el){el.textContent=n});}
function renderCart(cart){
  var items=$('#cartItems');if(!items)return;
  badge(cart.item_count);
  if(!cart.items.length){items.innerHTML='<p class="cart-empty">Cart is empty — the catalogue isn\'t.</p>';}
  else{items.innerHTML=cart.items.map(function(it,ix){
    var img=it.image?'<img src="'+it.image+'&width=160" alt="" width="64" height="64" style="object-fit:contain" onerror="this.style.display=\'none\'">':'<span></span>';
    return '<div class="cart-item">'+img+
      '<div><a class="ci-name" href="'+it.url+'">'+it.product_title+'</a>'+
      '<div class="ci-meta"><div class="qty">'+
      '<button data-line="'+(ix+1)+'" data-dq="-1" data-cursor aria-label="Decrease">−</button><span>'+it.quantity+'</span>'+
      '<button data-line="'+(ix+1)+'" data-dq="1" data-cursor aria-label="Increase">+</button></div>'+
      '<button class="ci-remove" data-line="'+(ix+1)+'" data-dq="-'+it.quantity+'" data-cursor>Remove</button></div></div>'+
      '<span class="ci-price">'+money(it.final_line_price)+'</span></div>';}).join('');}
  var t=$('#cartTotal');if(t)t.textContent=money(cart.total_price);
}
function fetchCart(){return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){renderCart(c);return c});}
function openDrawer(){if(!drawer)return;fetchCart();drawer.classList.add('is-open');
  document.body.classList.add('locked');document.body.style.overflow='hidden';}
function closeDrawer(){if(!drawer)return;drawer.classList.remove('is-open');
  document.body.classList.remove('locked');document.body.style.overflow='';}
document.addEventListener('click',function(e){
  if(e.target.closest('[data-cart-open]')){e.preventDefault();openDrawer();}
  if(e.target.closest('[data-cart-close]'))closeDrawer();
  var q=e.target.closest('[data-line]');
  if(q){var line=+q.getAttribute('data-line'),dq=+q.getAttribute('data-dq');
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      var newQty=Math.max(0,c.items[line-1].quantity+dq);
      return fetch('/cart/change.js',{method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({line:line,quantity:newQty})});
    }).then(function(r){return r.json()}).then(renderCart)
      .catch(function(){toast('Could not update cart — try again')});}
});
/* ---------- FOOTER LOCALIZATION SELECTS ---------- */
document.addEventListener('change',function(e){
  var sel=e.target.closest('[data-loc-select]');
  if(sel&&sel.form)sel.form.submit();
});

/* ---------- MOBILE MENU ---------- */
var mnav=$('#mnav');
function openMenu(){if(!mnav)return;mnav.classList.add('is-open');mnav.setAttribute('aria-hidden','false');
  var b=$('[data-menu-open]');if(b)b.setAttribute('aria-expanded','true');
  document.body.classList.add('locked');document.body.style.overflow='hidden';}
function closeMenu(){if(!mnav)return;mnav.classList.remove('is-open');mnav.setAttribute('aria-hidden','true');
  var b=$('[data-menu-open]');if(b)b.setAttribute('aria-expanded','false');
  if(!(drawer&&drawer.classList.contains('is-open'))){document.body.classList.remove('locked');document.body.style.overflow='';}}
document.addEventListener('click',function(e){
  if(e.target.closest('[data-menu-open]')){e.preventDefault();openMenu();}
  if(e.target.closest('[data-menu-close]'))closeMenu();
  if(e.target.closest('.mnav-links a'))closeMenu();
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDrawer();closeMenu();}});

/* add-to-cart form intercept */
$$('form[data-product-form]').forEach(function(form){
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=form.querySelector('.add-btn'),orig=btn.textContent;
    btn.textContent='Adding…';btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),
      headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){if(!r.ok)throw 0;return r.json()})
      .then(function(){btn.textContent='Added ✓';
        setTimeout(function(){btn.textContent=orig;btn.disabled=false},1600);
        openDrawer();})
      .catch(function(){btn.textContent=orig;btn.disabled=false;
        toast('Could not add — check availability');});
  });
});

/* qty steppers on PDP */
document.addEventListener('click',function(e){
  var m=e.target.closest('[data-qminus]'),p=e.target.closest('[data-qplus]');
  if(!m&&!p)return;
  var input=(m||p).parentElement.querySelector('input[name="quantity"]');
  var v=parseInt(input.value||'1',10);
  input.value=Math.min(9,Math.max(1,v+(p?1:-1)));
});

/* ---------- PRODUCT CAROUSEL ---------- */
function initCarousels(scope){
$$('[data-carousel]',scope).forEach(function(car){
  if(car.dataset.carInit)return;car.dataset.carInit='1';
  var track=car.querySelector('[data-track]');if(!track)return;
  var slides=track.children,dotsBox=car.querySelector('[data-dots]');
  if(slides.length<2)return;
  var dots=[];
  if(dotsBox){
    for(var i=0;i<slides.length;i++){
      (function(ix){
        var d=document.createElement('button');
        d.setAttribute('aria-label','Image '+(ix+1));
        d.addEventListener('click',function(){track.scrollTo({left:ix*track.clientWidth,behavior:'smooth'})});
        dotsBox.appendChild(d);dots.push(d);
      })(i);
    }
  }
  function setDot(){
    var ix=Math.round(track.scrollLeft/track.clientWidth);
    dots.forEach(function(d,i){d.classList.toggle('is-on',i===ix)});
  }
  setDot();
  var raf=null;
  track.addEventListener('scroll',function(){
    if(raf)return;raf=requestAnimationFrame(function(){setDot();raf=null});
  },{passive:true});
  var prev=car.querySelector('[data-prev]'),next=car.querySelector('[data-next]');
  if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-track.clientWidth,behavior:'smooth'})});
  if(next)next.addEventListener('click',function(){track.scrollBy({left:track.clientWidth,behavior:'smooth'})});
});
}
initCarousels(document);

/* ---------- PRODUCT VIDEOS (autoplay in view, pause out of view) ---------- */
function initPdpVideos(scope){
  $$('.pdp-media video[autoplay]',scope).forEach(function(v){
    if(v.dataset.pvInit)return;v.dataset.pvInit='1';
    v.muted=true;v.setAttribute('playsinline','');
    if(reduced){v.removeAttribute('autoplay');v.pause();v.controls=true;return;}
    if('IntersectionObserver' in window){
      var vio=new IntersectionObserver(function(es){es.forEach(function(en){
        if(en.isIntersecting){var p=en.target.play();if(p&&p.catch)p.catch(function(){});}
        else en.target.pause();
      })},{threshold:.35});
      vio.observe(v);
    }else{var p=v.play();if(p&&p.catch)p.catch(function(){});}
  });
}
initPdpVideos(document);

/* ---------- VARIANT IMAGE SWITCH ---------- */
function goToMedia(mediaId){
  if(!mediaId)return;
  var target=$('[data-media-id="'+mediaId+'"]');
  if(!target)return;
  var track=target.closest('[data-track]');
  /* carousel mode: the track scrolls sideways */
  if(track && track.scrollWidth > track.clientWidth+4){
    track.scrollTo({left:target.offsetLeft,behavior:'smooth'});
    return;
  }
  /* stacked mode: scroll the gallery column, or the page if it isn't scrollable */
  var sp=target.closest('.pdp-media');
  if(sp && sp.scrollHeight > sp.clientHeight+4){
    sp.scrollTo({top:sp.scrollTop+(target.getBoundingClientRect().top-sp.getBoundingClientRect().top),behavior:'smooth'});
    return;
  }
  var navh=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--navh'))||64;
  window.scrollTo({top:window.pageYOffset+target.getBoundingClientRect().top-navh,behavior:'smooth'});
}

/* variant select: price + swap to the variant's linked image */
var vs=$('#variantSelect');
var variantMediaEl=$('script[data-variant-media]');
var variantMediaMap=null;
if(variantMediaEl){
  try{variantMediaMap=JSON.parse(variantMediaEl.textContent);}catch(e){variantMediaMap=null;}
}
if(vs){vs.addEventListener('change',function(){
  var opt=vs.options[vs.selectedIndex],pr=$('#pdpPrice');
  if(pr&&opt)pr.textContent=opt.getAttribute('data-price');
  if(variantMediaMap){
    var mediaId=variantMediaMap[vs.value];
    if(mediaId)goToMedia(mediaId);
  }
  syncVariantState(true);
});}

/* ---------- VARIANT AVAILABILITY / BACK-IN-STOCK HOOKS ----------
   Keeps the add-to-cart button honest about the *selected* variant rather
   than the product as a whole, and publishes that state in the shapes
   back-in-stock apps look for: a disabled button[name="add"], a
   data-variant-available flag, ?variant= in the URL, and a variant:change
   event. Without this a sold-out variant still rendered an enabled
   "Add to cart", so the app had nothing to attach to. */
function syncVariantState(fromChange){
  var form=$('form[data-product-form]');
  if(!form)return;
  var btn=form.querySelector('.add-btn');
  if(!btn)return;
  var sel=form.querySelector('[data-variant-select]');
  var available,id;

  if(sel){
    var opt=sel.options[sel.selectedIndex];
    available=opt?opt.getAttribute('data-available')!=='false':true;
    id=sel.value;
  }else{
    var hid=form.querySelector('input[name="id"]');
    id=hid?hid.value:'';
    available=form.getAttribute('data-product-available')!=='false';
  }

  btn.disabled=!available;
  btn.textContent=available
    ?(btn.getAttribute('data-label-add')||'Add to cart')
    :(btn.getAttribute('data-label-sold')||'Sold out');

  form.setAttribute('data-variant-available',available?'true':'false');
  var slot=$('[data-notify-slot]');
  if(slot)slot.setAttribute('data-variant-available',available?'true':'false');

  /* Only rewrite the URL on a real selection, never on first paint. */
  if(fromChange&&id&&window.history&&history.replaceState){
    try{
      var u=new URL(window.location.href);
      u.searchParams.set('variant',id);
      history.replaceState({},'',u.toString());
    }catch(e){}
  }

  document.dispatchEvent(new CustomEvent('variant:change',{
    bubbles:true,detail:{variant:{id:id,available:available}}
  }));
}
syncVariantState(false);

/* mm/in toggle from metafields */
var ut=$('.unit-toggle');
if(ut && ut.getAttribute('data-w')){
  ut.addEventListener('click',function(e){
    var b=e.target.closest('[data-unit]');if(!b)return;
    $$('button',ut).forEach(function(x){x.classList.remove('is-on')});
    b.classList.add('is-on');
    var mm=b.getAttribute('data-unit')==='mm';
    var w=+ut.getAttribute('data-w'),h=+ut.getAttribute('data-h');
    var f=function(v){return mm?v+' mm':(v/25.4).toFixed(1)+' in'};
    var wEl=document.querySelector('[data-dim="w"]'),hEl=document.querySelector('[data-dim="h"]');
    if(wEl)wEl.textContent=f(w); if(hEl)hEl.textContent=f(h);
  });
}

/* ---------- SPOTLIGHT REVEAL (CSS-mask: any media over any media) ---------- */
function initSpotlight(scope){
  $$('[data-spotlight]',scope).forEach(function(sec){
    if(sec.dataset.spotInit)return;sec.dataset.spotInit='1';
    var reveal=sec.querySelector('.spot-reveal');
    var vids=$$('.spot-media-video',sec);
    var baseR=parseFloat(sec.getAttribute('data-radius'))||520;
    var mode=sec.getAttribute('data-play')||'hover';
    var N=6,pts=[],k;
    for(k=0;k<N;k++)pts.push({x:-1000,y:-1000});
    var tx=-1000,ty=-1000;
    function sizeR(){
      if(!reveal)return;
      var r=Math.min(baseR,innerWidth*0.45);
      for(var m=0;m<N;m++)reveal.style.setProperty('--r'+m,Math.max(30,r-m*35)+'px');
    }
    sizeR();
    addEventListener('resize',sizeR);
    function setTarget(cx,cy){
      var bb=sec.getBoundingClientRect();
      tx=cx-bb.left;ty=cy-bb.top;
    }
    if(reveal && !reduced){
      sec.addEventListener('mousemove',function(e){setTarget(e.clientX,e.clientY)});
      sec.addEventListener('touchmove',function(e){
        var t=e.touches&&e.touches[0];if(t)setTarget(t.clientX,t.clientY);
      },{passive:true});
      (function step(){
        if(!document.documentElement.contains(sec))return;
        pts[0].x+=(tx-pts[0].x)*.2;pts[0].y+=(ty-pts[0].y)*.2;
        for(var m=1;m<N;m++){
          pts[m].x+=(pts[m-1].x-pts[m].x)*.35;
          pts[m].y+=(pts[m-1].y-pts[m].y)*.35;
        }
        for(var m=0;m<N;m++){
          reveal.style.setProperty('--x'+m,pts[m].x+'px');
          reveal.style.setProperty('--y'+m,pts[m].y+'px');
        }
        requestAnimationFrame(step);
      })();
    }else if(reveal){
      var bb=sec.getBoundingClientRect();
      for(var m=0;m<N;m++){
        reveal.style.setProperty('--x'+m,(bb.width/2)+'px');
        reveal.style.setProperty('--y'+m,(bb.height/2)+'px');
      }
    }
    if(vids.length){
      var touch=!window.matchMedia('(hover:hover) and (pointer:fine)').matches;
      function playAll(){vids.forEach(function(v){var p=v.play();if(p&&p.catch)p.catch(function(){})})}
      function pauseAll(){vids.forEach(function(v){v.pause()})}
      if(reduced){pauseAll();}
      else if(mode==='always'||touch){playAll();}
      else{
        sec.addEventListener('mouseenter',playAll);
        sec.addEventListener('mouseleave',pauseAll);
      }
    }
  });
}
initSpotlight(document);

/* ---------- THEME EDITOR RE-RENDER SUPPORT ----------
   Shopify's customizer swaps section HTML in place without reloading scripts;
   these handlers re-initialise whatever was re-rendered so nothing gets stuck
   in a pre-animation state (the "hero drops down" bug). */
function killDetachedTriggers(){
  if(!(hasGsap&&window.ScrollTrigger))return;
  ScrollTrigger.getAll().forEach(function(st){
    var t=st.trigger;
    if(t&&t.nodeType===1&&!document.documentElement.contains(t))st.kill(true);
  });
}
/* ---------- LOCALIZATION (currency / country pickers) ---------- */
/* Two jobs here.
   1. Submit the form as soon as a choice is made, so there's no separate
      "update" button to hunt for.
   2. Re-assert the value the server rendered. Browsers restore a <select>'s
      previous value on reload and on back/forward (bfcache), which is what
      makes a picker drift out of sync with the currency the page is actually
      priced in. data-selected carries the authoritative value. */
function syncLocSelect(sel){
  var want=sel.getAttribute('data-selected');
  if(want&&sel.value!==want)sel.value=want;
}
function initLoc(root){
  $$('[data-loc-select]',root||document).forEach(function(sel){
    syncLocSelect(sel);
    if(sel.dataset.locBound)return;
    sel.dataset.locBound='1';
    sel.addEventListener('change',function(){
      if(sel.form){sel.setAttribute('aria-busy','true');sel.form.submit();}
    });
  });
}
addEventListener('pageshow',function(e){
  if(e.persisted)$$('[data-loc-select]').forEach(syncLocSelect);
});
initLoc(document);

document.addEventListener('shopify:section:load',function(e){
  var root=(e&&e.target)||document;
  killDetachedTriggers();
  if(root.querySelector('.hero-title'))heroIn();
  initAssembly();
  initReveals(root);
  initCounters(root);
  setupMarquee(root.querySelector('#marqueeTrack'));
  setupMarquee(root.querySelector('#announceTrack'));
  initCarousels(root);
  initPdpVideos(root);
  initSpotlight(root);
  initLoc(root);
  setHdr();
  if(hasGsap&&!reduced&&window.ScrollTrigger)ScrollTrigger.refresh();
});
document.addEventListener('shopify:section:unload',function(){
  killDetachedTriggers();setHdr();
  if(hasGsap&&!reduced&&window.ScrollTrigger)ScrollTrigger.refresh();
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
